"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageLoader = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

var _random2 = _interopRequireDefault(require("lodash/random"));

var _palette = require("@artsy/palette");

var _react = _interopRequireDefault(require("react"));

var _renderprops = require("react-spring/renderprops.cjs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A top-level loading bar used when transitioning between pages.
 *
 * Spec: https://app.zeplin.io/project/5acd19ff49a1429169c3128b/screen/5d7166295b4fca9d4724c13d
 */
var PageLoader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PageLoader, _React$Component);

  function PageLoader(props) {
    var _this;

    _classCallCheck(this, PageLoader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PageLoader).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      progress: 0,
      step: (0, _random2.default)(1, _this.props.step)
    });

    _defineProperty(_assertThisInitialized(_this), "currentProgress", 0);

    _defineProperty(_assertThisInitialized(_this), "interval", void 0);

    _this.currentProgress = _this.props.percentComplete || 0;
    _this.state = {
      progress: _this.currentProgress,
      step: _this.state.step
    };
    return _this;
  }

  _createClass(PageLoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.interval = setInterval(function () {
        _this2.currentProgress += _this2.state.step;

        _this2.setState({
          progress: Math.round(Math.atan(_this2.currentProgress) / (Math.PI / 1.5) * 100 * 1000) / 1000
        });
      }, 100);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          showBackground = _this$props.showBackground,
          style = _this$props.style,
          className = _this$props.className;
      var progress = this.state.progress;
      var isComplete = progress === 100;
      var animation = {
        from: {
          opacity: 0,
          top: 0
        },
        to: {
          opacity: 1,
          top: 0
        }
      };
      return _react.default.createElement(_palette.Box, {
        width: "100%",
        style: style,
        className: className
      }, _react.default.createElement(_renderprops.Spring, {
        from: animation.from,
        to: animation.to,
        reverse: isComplete
      }, function (animationProps) {
        return _react.default.createElement(_palette.Box, {
          style: animationProps,
          position: "relative"
        }, _react.default.createElement(_palette.ProgressBar, {
          percentComplete: progress,
          highlight: "purple100",
          showBackground: showBackground
        }));
      }));
    }
  }]);

  return PageLoader;
}(_react.default.Component);

exports.PageLoader = PageLoader;

_defineProperty(PageLoader, "defaultProps", {
  showBackground: true,
  style: {},
  step: 2
});
//# sourceMappingURL=PageLoader.js.map